export function computeBidders(): pbjs.Bid.Bidder[] {
  const searchParameters = new URLSearchParams(window.location.search);
  const isPrebidDebugMode = searchParameters.has("pbjs_debug");

  const debugBidders: Set<pbjs.Bid.Bidder["bidder"]> = isPrebidDebugMode
    ? new Set(
        (searchParameters.get("pbjs_debug_bidders")?.split(",") as pbjs.Bid.Bidder["bidder"][]) ?? [
          "appnexus" as const,
        ],
      )
    : new Set();

  return [
    createAppNexusBidder(),
    {
      bidder: "unruly",
      params: {
        siteId: 211_342,
      },
    },
    {
      bidder: "teads",
      params: {
        pageId: 109_129,
        placementId: 118_631,
      },
    },
    {
      bidder: "rubicon",
      params: {
        accountId: 16_912,
        siteId: 159_838,
        video: {},
        zoneId: 766_520,
      },
    },
    {
      bidder: "rubicon",
      params: {
        accountId: 16_912,
        siteId: 159_836,
        video: {},
        zoneId: 766_516,
      },
    },
    {
      bidder: "triplelift",
      params: {
        inventoryCode: "scmp_outstream_article",
      },
    },
  ];

  function createAppNexusBidder(): pbjs.Bid.AppNexus {
    return {
      bidder: "appnexus",
      params: {
        placementId: debugBidders.has("appnexus") ? 13_232_385 : 17_066_625,
      },
      renderer: {
        options: {
          disableCollapse: {
            enabled: true,
          },
          endCard: {
            enabled: true,
          },
        },
      },
    };
  }
}
